module.exports = __webpack_public_path__ + "img/workshop.99f91eda.jpg";